module.exports = __webpack_public_path__ + "static/media/website-about-image.979093fb.jpg";